import React, { useEffect, useState, useRef } from 'react';
export function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-white text-black py-24 sm:py-32 md:py-40 px-6 sm:px-12 md:px-16 lg:px-24 overflow-hidden" id="about" data-id="element-1504">
      <div className="container mx-auto max-w-7xl" data-id="element-1505">
        {/* Unified Section Header */}
        <div className="mb-16 sm:mb-24" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }} data-id="element-1506">
          <div className="text-xs tracking-[0.3em] uppercase text-slate-500 font-medium mb-4" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-1507">
            ABOUT
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 leading-tight mb-6" style={{
          fontFamily: "'Gefika', sans-serif"
        }} data-id="element-1508">
            About Me
          </h2>
          <div className="w-12 h-px bg-slate-900" data-id="element-1509"></div>
        </div>

        <div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-16" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
        transition: 'opacity 0.8s ease-out 0.15s, transform 0.8s ease-out 0.15s'
      }} data-id="element-1510">
          {/* Left column with image and meta strip */}
          <div className="lg:col-span-5 mb-12 lg:mb-0" data-id="element-1511">
            <div className="bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden aspect-[4/5] w-full max-w-sm" data-id="element-1512">
              <img src="https://cdn.magicpatterns.com/uploads/8FN6MVYdTZWchFWY5AGpqb/9236f44f5ce18172.jpg" alt="Mateo Cohen portrait" className="w-full h-full object-cover" style={{
              objectPosition: 'center 20%'
            }} data-id="element-1513" />
            </div>

            {/* Meta Strip */}
            <div className="mt-6 grid grid-cols-3 gap-4 sm:gap-6 max-w-sm" data-id="element-1514">
              <div data-id="element-1515">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1516">
                  Location
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1517">
                  Ohio, USA
                </div>
              </div>
              <div data-id="element-1518">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1519">
                  Currently
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1520">
                  Eli Lilly
                </div>
              </div>
              <div data-id="element-1521">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1522">
                  Open to
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1523">
                  AI + Design roles
                </div>
              </div>
            </div>
          </div>

          {/* Right column with text */}
          <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-1524">
            <p className="text-lg sm:text-xl font-normal leading-relaxed text-slate-800 mb-8" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-1525">
              Right now I'm at Eli Lilly working on clinical trial data
              orchestration, helping teams find where intelligent automation
              drives real value versus where it just adds friction. Beyond that,
              I love the creative adventure of a project and telling stories
              through the work. You have to enjoy the journey, and I love
              jumping into a fresh set of problems. The harder the challenge,
              the better.
            </p>

            <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-prose mb-6" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-1526">
              I see AI as infrastructure, not a feature, and I build on the
              cutting edge of what's actually useful. Amira is a system that
              travels with you and molds to any stack, housing whatever AI tech
              you bring. Real value comes from knowing a tool well enough to
              wield it, and Amira is built to teach you how.
            </p>

            <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-prose mb-6 sm:mb-8" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-1527">
              My approach balances high-level logic with rapid prototyping,
              sharpened by an AI executive program at Northwestern. Based in
              Ohio, I spend my downtime producing electronic music, coaching
              youth soccer, and experimenting with emerging tech in a highly
              creative household.
            </p>
          </div>
        </div>
      </div>
    </section>;
}